import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomJsService } from "src/app/shared/custom-js.service";
import { SportService } from "src/app/sports/sport.service";

declare var $: any;

@Component({
    selector: "app-public-sport-highlight",
    templateUrl: "./public-sport-highlight.component.html",
    styleUrls: ["./public-sport-highlight.component.scss"],
})
export class PublicSportHighlightComponent implements OnInit {
    public highlights: any = null;
    constructor(
        private spinner: NgxSpinnerService,
        private sportService: SportService,
        private customJs: CustomJsService
    ) {
        this.spinner.show();
        document.querySelector("body").classList.add("public-content");
        this.sportService.getPublicHighlight().subscribe((res) => {
            this.highlights = res.result;

            setTimeout(() => {
                $(".slider").slick({
                    // normal options...
                    infinite: false,

                    // the magic
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                infinite: true,
                            },
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                dots: true,
                            },
                        },
                        {
                            breakpoint: 300,
                            settings: "unslick", // destroys slick
                        },
                    ],
                });

                this.spinner.hide();
            }, 1000);
        });
    }

    ngOnInit() {}
}
